import React, { useEffect, useState } from 'react';
import axios from 'axios';

const AdminDashboard = () => {
  const [workers, setWorkers] = useState([]);

  useEffect(() => {
    const fetchPending = async () => {
      try {
        const res = await axios.get('/api/admin/pending-workers');
        setWorkers(res.data);
      } catch (err) {
        console.error('Failed to fetch pending workers:', err);
      }
    };

    fetchPending();
  }, []);

  const updateStatus = async (workerId, status) => {
    try {
      await axios.post('/api/admin/update-status', { workerId, status });
      alert(`Worker ${status}`);
      setWorkers((prev) => prev.filter((w) => w._id !== workerId));
    } catch (err) {
      console.error('Update failed:', err);
      alert('Could not update worker status');
    }
  };

  return (
    <div className="p-6 max-w-5xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Pending Worker Approvals</h1>

      {workers.length === 0 ? (
        <p>No pending workers.</p>
      ) : (
        <ul className="space-y-4">
          {workers.map((w) => (
            <li key={w._id} className="p-4 border bg-white rounded shadow-sm">
              <p><strong>Name:</strong> {w.name}</p>
              <p><strong>Email:</strong> {w.email}</p>
              <p><strong>Status:</strong> {w.status}</p>

              <h4 className="mt-2 font-semibold">Services:</h4>
              <ul className="list-disc ml-6">
                {w.services.map((s, i) => (
                  <li key={i}>
                    {s.name} –{' '}
                    {s.certUrl ? (
                      <a
                        href={s.certUrl}
                        target="_blank"
                        rel="noreferrer"
                        className="text-blue-600 underline"
                      >
                        View Cert
                      </a>
                    ) : (
                      <span className="text-gray-400 italic">No cert</span>
                    )}
                  </li>
                ))}
              </ul>

              <div className="mt-4 space-x-4">
                <button
                  onClick={() => updateStatus(w._id, 'approved')}
                  className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
                >
                  Approve
                </button>
                <button
                  onClick={() => updateStatus(w._id, 'rejected')}
                  className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                >
                  Reject
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AdminDashboard;
